import { Component, Input, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { AuthService, BlockAbstractComponent, PageService, PageType, ParserService } from '@gallaghercp/core-frontend';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_CONFIG } from '../../../app.config';

@Component({
  selector: 'coro-page-template',
  templateUrl: './coro-page-template.component.html',
  styleUrl: './coro-page-template.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class CoroPageTemplateComponent extends BlockAbstractComponent implements OnInit {
  protected override parser: ParserService;
  protected override auth: AuthService;
  protected override pages: PageService;

  //Properties
  currentPageName?: string;
  theIcon?: string;
  frontend?: string = APP_CONFIG.frontend!;
  theChildren?: any;

  //Breadcrumbs
  @Input() page?: any;

  loading = true;
  isParentBreadcrumb = false;

  breadcrumbs$!: Observable<PageType>;

  date: number = Date.now();
  showDate!: boolean;
  showBreadcrumbs!: boolean;

  constructor() {
    const parser = inject(ParserService);
    const auth = inject(AuthService);
    const pages = inject(PageService);

    super(parser, auth, pages);

    this.parser = parser;
    this.auth = auth;
    this.pages = pages;
  }

  override ngOnInit() {
    super.ngOnInit();

    this.showDate = false;
    this.showBreadcrumbs = true;

    this.subscriptions.push(
      this.pages.currentPage$.subscribe((page: PageType) => {
        if (page) {
          this.currentPage = page;

          this.breadcrumbs$ = this.getBreadcrumbs(this.currentPage);

          this.currentPageName = this.currentPage!.name;

          this.theIcon = APP_CONFIG.frontend! + this.currentPage!.meta!.icon!;

          // Log the children of the current page
          this.theChildren = this.currentPage.children;
        }
      }),
    );
  }

  getBreadcrumbs(requestedPage: PageType): Observable<any> {
    return this.pages.getPages(this.createHeaders(requestedPage)).pipe(
      map((pages: PageType[]) => {
        const breadcrumbs: Record<number, any> = {};
        const extractIds = (page: PageType, parents: any[]) => {
          const { id, children, ...rest } = page;
          const pageMin = this.omitUnnecessaryFields(rest);
          pageMin.parents = parents.map((parent: PageType) => ({
            ...parent,
            name: this.translateService.getPageSpecific(parent, 'name'),
            description: this.translateService.getPageSpecific(parent, 'description'),
            url: this.translateService.getPageSpecific(parent, 'url'),
          }));
          breadcrumbs[id] = {
            ...pageMin,
            name: this.translateService.getPageSpecific(pageMin, 'name'),
            description: this.translateService.getPageSpecific(pageMin, 'description'),
            url: this.translateService.getPageSpecific(pageMin, 'url'),
          };
          children.forEach((child: any) => extractIds(child, [...parents, pageMin]));
        };
        pages.forEach((page: any) => extractIds(page, []));
        this.loading = false;
        return breadcrumbs[requestedPage.id] ?? [];
      }),
    );
  }

  private createHeaders(requestedPage: { id: number; zone: number }): any {
    const headers: any = {};
    const { zone } = requestedPage;
    if (zone && zone > 1) {
      headers['x-service-zone'] = String(zone);
    }
    return headers;
  }

  private omitUnnecessaryFields(page: any): any {
    const { createdBy, dateCreated, displayOrder, groups, hidden, lastUpdated, permissions, tags, widgets, ...rest } =
      page;
    return rest;
  }

  getLink(breadcrumb: PageType) {
    return '/' + breadcrumb.url;
  }

  kebabCaseTemplateType(templateType: string): string {
    if (templateType === 'Article') return 'article-template';
    if (templateType === 'Category Landing') return 'category-landing-template';
    if (templateType === 'Contacts') return 'contacts-template';
    if (templateType === 'Interior') return 'interior-template';
    if (templateType === 'Search') return 'search-template';

    return 'NO_TEMPLATE_TYPE_SET';
  }
}
